import React from 'react';
import { Button, Modal, DatePicker } from 'antd';

import PageFrame from '../../views/PageFrame';
import Clamper from '../../views/ContentWidthClamper';
import HeadlineBreadcrumbList from '../../views/HeadlineBreadcrumbList';
import ContentHeader from '../../views/ContentHeader';
import StyledTable from '../../views/StyledTable';
import ButtonList from '../../views/ButtonList';
import ReCatModal from './ReCatModal';

export default ({
  title, goHome, columns, isLoading, data, goNew, scrollY, showReCatModal, closeModal, categoryObj, token = {},
}) => (
  <PageFrame noBottom>
    <Clamper>
      <ContentHeader>
        <HeadlineBreadcrumbList>
          {[
            { onClick: goHome, text: 'Home' },
            title,
          ]}
        </HeadlineBreadcrumbList>
        <ButtonList compact line={false} style={({ flex: 1 })}>
          <Button type="primary" icon="plus" onClick={goNew}>New</Button>
        </ButtonList>
      </ContentHeader>
      <StyledTable
        id="categories"
        columns={columns}
        pagination={false}
        dataSource={data}
        loading={isLoading}
        rowKey="categoryName"
        scroll={({ y: scrollY })}
      />
      <ReCatModal showReCatModal={showReCatModal} closeModal={closeModal} categoryObj={categoryObj} token={token} />
    </Clamper>
  </PageFrame>
);
